import {
    UPDATE_DISCLAIMER_STATUS_REQUEST,
    UPDATE_DISCLAIMER_STATUS_SUCCESS,
    UPDATE_DISCLAIMER_STATUS_FAILURE,
} from '../../../../Constants/actionTypes';


const initialState = {
    loading: false,
    updateStatus: null,
    error: null,
  };
  
  const updateStatusReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_DISCLAIMER_STATUS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case UPDATE_DISCLAIMER_STATUS_SUCCESS:
        return {
          ...state,
          loading: false,
          updateStatus: 'success',
        };
      case UPDATE_DISCLAIMER_STATUS_FAILURE:
        return {
          ...state,
          loading: false,
          updateStatus: 'failure',
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default updateStatusReducer;